import address from '@/api/corporate/address'

import { baseState, baseMutations } from '@/store/mixins'
import { mapKeys, camelCase } from 'lodash'

class DistrictPaginate {
  constructor(paging = {}) {
    this.currentPage = paging.currentPage ? parseInt(paging.currentPage) : 1
    this.lastPage = paging.lastPage ? parseInt(paging.lastPage) : 0
    this.perPage = paging.perPage ? parseInt(paging.perPage) : 15
    this.total = paging.total ? parseInt(paging.total) : 0
    this.from = this.perPage * (this.currentPage - 1) + 1
    this.to = this.perPage * this.currentPage
  }
}
class CommunePaginate {
  constructor(paging = {}) {
    this.currentPage = paging.currentPage ? parseInt(paging.currentPage) : 1
    this.lastPage = paging.lastPage ? parseInt(paging.lastPage) : 0
    this.perPage = paging.perPage ? parseInt(paging.perPage) : 15
    this.total = paging.total ? parseInt(paging.total) : 0
    this.from = this.perPage * (this.currentPage - 1) + 1
    this.to = this.perPage * this.currentPage
  }
}
class VillagePaginate {
  constructor(paging = {}) {
    this.currentPage = paging.currentPage ? parseInt(paging.currentPage) : 1
    this.lastPage = paging.lastPage ? parseInt(paging.lastPage) : 0
    this.perPage = paging.perPage ? parseInt(paging.perPage) : 15
    this.total = paging.total ? parseInt(paging.total) : 0
    this.from = this.perPage * (this.currentPage - 1) + 1
    this.to = this.perPage * this.currentPage
  }
}

export const state = {
  ...baseState,
  districtPaginate: new DistrictPaginate(),
  communePaginate: new CommunePaginate(),
  villagePaginate: new VillagePaginate(),
  districtResources: [],
  communeResources: [],
  villageResources: []
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  RECEIVE_RESOURCES_DISTRICT(state, { data, ...meta }) {
    state.districtResources = []
    data.forEach(resource => {
      state.districtResources.push(Object.assign(resource, { _deleting: false }))
    })
    state.districtPaginate = new DistrictPaginate(mapKeys(meta.meta, (v, k) => camelCase(k)))
  },
  RECEIVE_RESOURCES_COMMUNE(state, { data, ...meta }) {
    state.communeResources = []
    data.forEach(resource => {
      state.communeResources.push(Object.assign(resource, { _deleting: false }))
    })
    state.communePaginate = new CommunePaginate(mapKeys(meta.meta, (v, k) => camelCase(k)))
  },
  RECEIVE_RESOURCES_VILLAGE(state, { data, ...meta }) {
    state.villageResources = []
    data.forEach(resource => {
      state.villageResources.push(Object.assign(resource, { _deleting: false }))
    })
    state.villagePaginate = new VillagePaginate(mapKeys(meta.meta, (v, k) => camelCase(k)))
  },
}

export const actions = {
  async getFormViewData(context, { params }) {
    let response = await address.formModel({ params: params })
    return response;
  },
  districtFetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        filter: {
          search: context.state.search
        }
      },
      attrubutes
    )
    return address.getDistrict({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES_DISTRICT', response)
      return Promise.resolve(response)
    })
  },
  communeFetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        filter: {
          search: context.state.search
        }
      },
      attrubutes
    )
    return address.getCommune({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES_COMMUNE', response)
      return Promise.resolve(response)
    })
  },
  villageFetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        filter: {
          search: context.state.search
        }
      },
      attrubutes
    )
    return address.getVillage({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES_VILLAGE', response)
      return Promise.resolve(response)
    })
  },
  district(context, data) {
    return address.district(data)
  },
  commune(context, data) {
    return address.commune(data)
  },
  village(context, data) {
    return address.village(data)
  }
}
